import React from 'react';
import { printPalette, printTypography } from './printPalette';

interface MainPrintLogoProps {
  companyName?: string;
  companyAddress?: string;
}

const MainPrintLogo: React.FC<MainPrintLogoProps> = ({
  companyName = 'CLAPOTIS CARRIERS LTD',
  companyAddress = 'Trust Company Complex, Ajeltake Road, Majuro, Marshall Islands',
}) => {
  return (
    <div style={styles.wrapper}>
      <img src="/fms_logo.png" alt="Company logo" style={styles.logo} />
      <h1 style={styles.companyName}>{companyName}</h1>
      <p style={styles.companyAddress}>{companyAddress}</p>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  wrapper: {
    textAlign: 'center',
    marginBottom: '20px',
  },
  logo: {
    width: '60px',
    height: 'auto',
    margin: '0 auto 8px auto',
    display: 'block',
  },
  companyName: {
    fontSize: `${printTypography.companyNameSize}px`,
    fontWeight: 'bold',
    margin: '0 0 5px 0',
    color: printPalette.primary,
  },
  companyAddress: {
    fontSize: `${printTypography.addressSize}px`,
    margin: 0,
    color: printPalette.secondaryDark,
  },
};

export default MainPrintLogo;


